import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import SORT_OPTIONS from 'shared/constants/json/vdieoSortOptions.json';
import { fetchNews } from 'shared/network/journal';
import { setOrderingField, getVideoById, setJournalNews } from 'shared/actions/journal';
import s from './VideoFiltersHeader.css';

const CURRENT_RUBRIC = 'video';
const SHOW_IN_VIDEO = 1;

const changFilter = async (filterName, _this) => {
  const {
    setOrderField,
    getSelVideo,
    setNews,
    videoFilters: { make, model, generation, topic },
  } = _this.props;

  const videos = await fetchNews({
    fetch,
    rubric: CURRENT_RUBRIC,
    [make && 'make']: make && make.id,
    [model && 'model']: model && model.id,
    [topic && 'topic']: topic && topic.slug,
    [generation && 'generation']: generation && generation.id,
    showInVideo: SHOW_IN_VIDEO,
    ordering: filterName.id === 'new' ? '' : '-views',
  });
  setNews(videos.results || []);
  setOrderField(filterName);
  getSelVideo();
};

class VideoFiltersHeader extends React.Component {
  static propTypes = {
    videoOrderBy: PropTypes.string.isRequired,
  };

  handleFilterChange = filterName => {
    changFilter(filterName, this);
  };

  render() {
    const { videoOrderBy } = this.props;
    return (
      <div className={s.root}>
        <div
          className={cx(s.item, { [s.active]: videoOrderBy.id === 'new' })}
          onClick={() => this.handleFilterChange(SORT_OPTIONS[0])}
        >
          <FormattedMessage id="Самые новые" />
        </div>
        <div
          className={cx(s.item, { [s.active]: videoOrderBy.id === 'popular' })}
          onClick={() => this.handleFilterChange(SORT_OPTIONS[1])}
        >
          <FormattedMessage id="Популярные" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  videoOrderBy: globals.journal.videoOrderBy,
  videoFilters: globals.journal.videoFilters,
});

const mapDispatchToProps = {
  setNews: setJournalNews,
  setOrderField: setOrderingField,
  getSelVideo: getVideoById,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(s)(VideoFiltersHeader));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/components/VideoFiltersHeader/VideoFiltersHeader.js